import { getAxiosClient } from "../../axios-client";
import { DeleteOfferRequestBody, DeleteOfferResponse } from "./types";

const axiosClient = getAxiosClient();
export const deleteOffer = async (body: DeleteOfferRequestBody) => {
  return await axiosClient.ax.delete<DeleteOfferResponse>(
    "/Offers/DeleteOffer",
    { data: body }
  );
};
